import { default as indexwirwMZY5KqMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/creator/new-rating/index.vue?macro=true";
import { default as indexPdXeX6JN72Meta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/creator/usage-notice/index.vue?macro=true";
import { default as indexWt3fS9AfsAMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/index.vue?macro=true";
import { default as indexknzrwHNsIlMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/kling/contribution/index.vue?macro=true";
import { default as rulesZkf9tpg8J5Meta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/kling/contribution/rules.vue?macro=true";
import { default as indexVyGgOxlO83Meta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/kmovie/remove-watermark/index.vue?macro=true";
import { default as alading6dQfv5w3pMMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ksky/alading.vue?macro=true";
import { default as feedback_45m2ua9LImC1sD2Meta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ksky/feedback-m2u.vue?macro=true";
import { default as feedbackZ1CPASzENvMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ksky/feedback.vue?macro=true";
import { default as ground_45pagesoMCiS1SpSMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ksky/ground-page.vue?macro=true";
import { default as indexeGEqHjyX4YMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ky-agreement/index.vue?macro=true";
import { default as kwaicutThzE5crGSMMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ky/kwaicut.vue?macro=true";
import { default as populartU7yjq7t9bMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ky/popular.vue?macro=true";
import { default as indexUmYazWPvUxMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/officialWebsite/index.vue?macro=true";
import { default as indexJylkD22daeMeta } from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/protocol/index.vue?macro=true";
export default [
  {
    name: indexwirwMZY5KqMeta?.name ?? "creator-new-rating",
    path: indexwirwMZY5KqMeta?.path ?? "/creator/new-rating",
    meta: indexwirwMZY5KqMeta || {},
    alias: indexwirwMZY5KqMeta?.alias || [],
    redirect: indexwirwMZY5KqMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/creator/new-rating/index.vue").then(m => m.default || m)
  },
  {
    name: indexPdXeX6JN72Meta?.name ?? "creator-usage-notice",
    path: indexPdXeX6JN72Meta?.path ?? "/creator/usage-notice",
    meta: indexPdXeX6JN72Meta || {},
    alias: indexPdXeX6JN72Meta?.alias || [],
    redirect: indexPdXeX6JN72Meta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/creator/usage-notice/index.vue").then(m => m.default || m)
  },
  {
    name: indexWt3fS9AfsAMeta?.name ?? "index",
    path: indexWt3fS9AfsAMeta?.path ?? "/",
    meta: indexWt3fS9AfsAMeta || {},
    alias: indexWt3fS9AfsAMeta?.alias || [],
    redirect: indexWt3fS9AfsAMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexknzrwHNsIlMeta?.name ?? "kling-contribution",
    path: indexknzrwHNsIlMeta?.path ?? "/kling/contribution",
    meta: indexknzrwHNsIlMeta || {},
    alias: indexknzrwHNsIlMeta?.alias || [],
    redirect: indexknzrwHNsIlMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/kling/contribution/index.vue").then(m => m.default || m)
  },
  {
    name: rulesZkf9tpg8J5Meta?.name ?? "kling-contribution-rules",
    path: rulesZkf9tpg8J5Meta?.path ?? "/kling/contribution/rules",
    meta: rulesZkf9tpg8J5Meta || {},
    alias: rulesZkf9tpg8J5Meta?.alias || [],
    redirect: rulesZkf9tpg8J5Meta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/kling/contribution/rules.vue").then(m => m.default || m)
  },
  {
    name: indexVyGgOxlO83Meta?.name ?? "kmovie-remove-watermark",
    path: indexVyGgOxlO83Meta?.path ?? "/kmovie/remove-watermark",
    meta: indexVyGgOxlO83Meta || {},
    alias: indexVyGgOxlO83Meta?.alias || [],
    redirect: indexVyGgOxlO83Meta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/kmovie/remove-watermark/index.vue").then(m => m.default || m)
  },
  {
    name: alading6dQfv5w3pMMeta?.name ?? "ksky-alading",
    path: alading6dQfv5w3pMMeta?.path ?? "/ksky/alading",
    meta: alading6dQfv5w3pMMeta || {},
    alias: alading6dQfv5w3pMMeta?.alias || [],
    redirect: alading6dQfv5w3pMMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ksky/alading.vue").then(m => m.default || m)
  },
  {
    name: feedback_45m2ua9LImC1sD2Meta?.name ?? "ksky-feedback-m2u",
    path: feedback_45m2ua9LImC1sD2Meta?.path ?? "/ksky/feedback-m2u",
    meta: feedback_45m2ua9LImC1sD2Meta || {},
    alias: feedback_45m2ua9LImC1sD2Meta?.alias || [],
    redirect: feedback_45m2ua9LImC1sD2Meta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ksky/feedback-m2u.vue").then(m => m.default || m)
  },
  {
    name: feedbackZ1CPASzENvMeta?.name ?? "ksky-feedback",
    path: feedbackZ1CPASzENvMeta?.path ?? "/ksky/feedback",
    meta: feedbackZ1CPASzENvMeta || {},
    alias: feedbackZ1CPASzENvMeta?.alias || [],
    redirect: feedbackZ1CPASzENvMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ksky/feedback.vue").then(m => m.default || m)
  },
  {
    name: ground_45pagesoMCiS1SpSMeta?.name ?? "ksky-ground-page",
    path: ground_45pagesoMCiS1SpSMeta?.path ?? "/ksky/ground-page",
    meta: ground_45pagesoMCiS1SpSMeta || {},
    alias: ground_45pagesoMCiS1SpSMeta?.alias || [],
    redirect: ground_45pagesoMCiS1SpSMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ksky/ground-page.vue").then(m => m.default || m)
  },
  {
    name: indexeGEqHjyX4YMeta?.name ?? "ky-agreement",
    path: indexeGEqHjyX4YMeta?.path ?? "/ky-agreement",
    meta: indexeGEqHjyX4YMeta || {},
    alias: indexeGEqHjyX4YMeta?.alias || [],
    redirect: indexeGEqHjyX4YMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ky-agreement/index.vue").then(m => m.default || m)
  },
  {
    name: kwaicutThzE5crGSMMeta?.name ?? "ky-kwaicut",
    path: kwaicutThzE5crGSMMeta?.path ?? "/ky/kwaicut",
    meta: kwaicutThzE5crGSMMeta || {},
    alias: kwaicutThzE5crGSMMeta?.alias || [],
    redirect: kwaicutThzE5crGSMMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ky/kwaicut.vue").then(m => m.default || m)
  },
  {
    name: populartU7yjq7t9bMeta?.name ?? "ky-popular",
    path: populartU7yjq7t9bMeta?.path ?? "/ky/popular",
    meta: populartU7yjq7t9bMeta || {},
    alias: populartU7yjq7t9bMeta?.alias || [],
    redirect: populartU7yjq7t9bMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/ky/popular.vue").then(m => m.default || m)
  },
  {
    name: indexUmYazWPvUxMeta?.name ?? "officialWebsite",
    path: indexUmYazWPvUxMeta?.path ?? "/officialWebsite",
    meta: indexUmYazWPvUxMeta || {},
    alias: indexUmYazWPvUxMeta?.alias || [],
    redirect: indexUmYazWPvUxMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/officialWebsite/index.vue").then(m => m.default || m)
  },
  {
    name: indexJylkD22daeMeta?.name ?? "protocol",
    path: indexJylkD22daeMeta?.path ?? "/protocol",
    meta: indexJylkD22daeMeta || {},
    alias: indexJylkD22daeMeta?.alias || [],
    redirect: indexJylkD22daeMeta?.redirect || undefined,
    component: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/pages/protocol/index.vue").then(m => m.default || m)
  }
]